const applicationOptions = {
  accept: 'video/webm',
  heroBannerImgUrl: 'https://cdn140.picsart.com/51762297790342751345.png',
  heroBannerImgAlt: 'convert webm to mp4 for free',
  appImageUrl: 'https://cdn140.picsart.com/51762297790342751345.png',
  multiple: false,
} as const;

export default applicationOptions;
